import React from "react";
import { useNavigate } from "react-router-dom";
import adminImage from '../../assets/images/user-placeholder.jpg';
import Logo from "../IconsPack/BiLogo";

interface Props {
  selectedNavItemLabel: string;
  userProfile: {
    name?: string;
    imageUrl?: string;
    profilePicture?: string;
    firstName?: string;
    lastName?: string;
  };
  onHamburgerClick: () => void; // New prop for hamburger button
}

const TopBar: React.FC<Props> = ({ selectedNavItemLabel, userProfile, onHamburgerClick }) => {
  const navigate = useNavigate();
  return (
    <div className="w-full flex h-[70px] items-center justify-between pl-8 pr-6 bg-white shadow-sm">
      <div className="flex items-center gap-2 block md:hidden">
        <button onClick={onHamburgerClick}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          {/* First line */}
          <rect x="2" y="5" width="20" height="2" fill="currentColor" />
          {/* Second line */}
          <rect x="2" y="11" width="20" height="2" fill="currentColor" />
          {/* Third line */}
          <rect x="2" y="17" width="20" height="2" fill="currentColor" />
        </svg>
        </button>
        <div className="h-[25px]">
          <Logo />
        </div>
      </div>

      <h3 className="text-[14px] text-gray-600 font-ubuntu font-[400] hidden md:block">
        Student {">"} {selectedNavItemLabel}
      </h3>


      <div className="cursor-pointer flex items-center">
        <div className="text-gray-600 font-ubuntu font-[400] flex items-center">
          <div
            className="w-11 h-11 rounded-full overflow-hidden mr-2"
            onClick={() => navigate("/profile")}
          >
            <img
              src={userProfile?.profilePicture ?? adminImage}
              alt={userProfile?.firstName}
              className="w-full h-full object-cover object-center"
            />
          </div>
          <span
            className="text-[14px] font-ubuntu font-[400] mr-2 hidden md:block"
            onClick={() => navigate("/profile")}
          >
            {userProfile?.firstName} {userProfile?.lastName}
          </span>
          <div className="h-7 border-r border-gray-300 mx-2"></div>
          <div className="text-gray-800 rounded-full p-2 cursor-pointer">
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_6667_532)">
                <path
                  d="M22.5765 19.3264C21.9068 18.7294 21.3206 18.045 20.8334 17.2917C20.3011 16.252 19.9824 15.1163 19.8959 13.9514V10.5209C19.9005 8.69142 19.2369 6.92327 18.0298 5.54862C16.8226 4.17397 15.1551 3.28743 13.3404 3.05558V2.15975C13.3404 1.91387 13.2427 1.67806 13.0688 1.5042C12.895 1.33034 12.6592 1.23267 12.4133 1.23267C12.1674 1.23267 11.9316 1.33034 11.7578 1.5042C11.5839 1.67806 11.4862 1.91387 11.4862 2.15975V3.06947C9.68779 3.31803 8.04037 4.20993 6.84909 5.57996C5.65781 6.95 5.00339 8.70534 5.00705 10.5209V13.9514C4.92063 15.1163 4.60187 16.252 4.06955 17.2917C3.591 18.0433 3.01413 18.7276 2.35428 19.3264C2.2802 19.3915 2.22083 19.4716 2.18012 19.5614C2.13941 19.6512 2.11829 19.7486 2.11816 19.8472V20.7917C2.11816 20.9759 2.19133 21.1525 2.32156 21.2827C2.4518 21.413 2.62843 21.4861 2.81261 21.4861H22.1182C22.3023 21.4861 22.479 21.413 22.6092 21.2827C22.7394 21.1525 22.8126 20.9759 22.8126 20.7917V19.8472C22.8125 19.7486 22.7914 19.6512 22.7507 19.5614C22.7099 19.4716 22.6506 19.3915 22.5765 19.3264ZM3.56261 20.0972C4.20858 19.4729 4.77744 18.7735 5.25705 18.0139C5.92774 16.7583 6.31864 15.3724 6.40289 13.9514V10.5209C6.37535 9.707 6.51186 8.89591 6.80431 8.13591C7.09675 7.3759 7.53914 6.68252 8.10514 6.09704C8.67114 5.51157 9.34916 5.04598 10.0988 4.72799C10.8485 4.41001 11.6545 4.24614 12.4689 4.24614C13.2832 4.24614 14.0892 4.41001 14.8389 4.72799C15.5886 5.04598 16.2666 5.51157 16.8326 6.09704C17.3986 6.68252 17.841 7.3759 18.1334 8.13591C18.4259 8.89591 18.5624 9.707 18.5348 10.5209V13.9514C18.6191 15.3724 19.01 16.7583 19.6807 18.0139C20.1603 18.7735 20.7291 19.4729 21.3751 20.0972H3.56261Z"
                  fill="black"
                />
                <path
                  d="M12.5 23.8055C12.9375 23.7954 13.3573 23.631 13.6852 23.3412C14.0131 23.0514 14.2279 22.6551 14.2917 22.2222H10.6389C10.7045 22.6668 10.9294 23.0725 11.2718 23.3638C11.6141 23.655 12.0506 23.812 12.5 23.8055Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_6667_532">
                  <rect width="25" height="25" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
